<script setup>
const props = defineProps({
  urlRoot: {
    type: String,
    default: 'https://api.github.com/users/PennockProjects/repos'
  },
  repoNames: {
    type: Array,
    default: () => []
  }
})

const {error, status, data} = await useFetch('https://api.github.com/users/PennockProjects/repos')

const repos = computed(
  () => data.value.filter(repo => {
    if(props.repoNames.length) {
        return props.repoNames.includes(repo.name)
      } else {
        return repo.name
      }
    })
    .sort((a, b) => b.stargazers_count - a.stargazers_count)
)

</script>

<template>
  <div class="not-prose">
    <section v-if="status.value=='pending'">Loading...</section>
    <section v-else-if="error">Something went wrong... Try again!</section>
    <section v-else>
      <ul class="flex flex-col">
        <li 
          v-for="repo in repos"
          :key="repo.id"
          class="border border-gray-200 dark:border-gray-700 rounded-sm p-2 md:p-4 max-w-xl font-mono bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 hover:dark:bg-gray-700">
          <a :href="repo.html_url" target="_blank">
            <div class="flex items-center justify-between text-sm">
              <div class="font-semibold">{{repo.name}}</div>
              <!-- <div>{{ repo.stargazers_count }} *</div> -->
            </div>
            <p class="text-sm">{{ repo.description }}</p>
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<style lang="">
  
</style>